import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import { useEffect } from "react";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CANCEL, SAVE } from "../../../shared/constants/Constants";

const GroupsForm = ({ groups, submit, cancel }) => {
    const validate = (values) => {
        const errors = {};
        if (!values.group_name) {
            errors.group_name = "Required";
        }
        return errors;
    };

    const formik = useFormik({});

    useEffect(() => {
        if (groups) {
            formik.current.setFieldValue("id", groups?.id);
            formik.current.setFieldValue("group_name", groups?.group_name);
        }
    }, [groups, formik]);

    return (
        <Formik
            innerRef={formik}
            initialValues={{
                group_name: "",
            }}
            validate={validate}
            onSubmit={submit}
        >
            {() => (
                <Form className="row g-4">
                    <div className="col-md-6">
                        <label htmlFor="group_name" className="form-label">
                            Group Name<span className="error-text">*</span>
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="group_name"
                            placeholder="Enter Group Name"
                            autoComplete="off"
                        />
                        <span className="error-text">
                            <ErrorMessage name="group_name" />
                        </span>
                    </div>
                    <div className="col-md-12">
                        <DefaultButton
                            buttonClass={"btn btn-secondary me-2"}
                            buttonTitle={CANCEL}
                            actionBlock={cancel}
                        />
                        <DefaultButton
                            buttonClass={"default-btn-color"}
                            buttonTitle={SAVE}
                            buttonType={"submit"}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default GroupsForm;
